module.exports = __webpack_public_path__ + "img/8.e245b1da.jpg";